import React from 'react';
import SafeIcon from '../common/SafeIcon';

const IndustryHero = ({ content }) => {
  return (
    <section className="relative pt-32 pb-12 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img src={content.image} className="w-full h-full object-cover opacity-20" alt={content.title} />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-950 via-slate-950/80 to-slate-950"></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-500/10 border border-blue-500/30 mb-8">
          <span className="text-sm font-bold text-blue-400 uppercase tracking-widest">{content.title} Edition</span>
        </div>
        
        <h1 className="text-5xl md:text-7xl font-extrabold text-white tracking-tight mb-8 leading-tight">
          {content.heroTitle}
        </h1>
        
        <p className="max-w-3xl mx-auto text-xl text-slate-300 mb-10 leading-relaxed">
          {content.heroSubtitle}
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <a href="#contact" className="w-full sm:w-auto bg-blue-600 hover:bg-blue-500 text-white px-8 py-4 rounded-full font-bold text-lg transition-all shadow-[0_0_20px_rgba(37,99,235,0.5)] flex items-center justify-center gap-2">
            Start {content.title.split(' ')[0]} Trial <SafeIcon name="ArrowRight" />
          </a>
          <a href="#calculator" className="w-full sm:w-auto bg-slate-800/80 backdrop-blur hover:bg-slate-700 text-white px-8 py-4 rounded-full font-bold text-lg transition-all border border-slate-700 flex items-center justify-center gap-2">
            View ROI Data <SafeIcon name="BarChart2" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default IndustryHero;